import { isObservable, from, of, Observable } from 'rxjs';

export function toObservable<T = any>(source: any): Observable<T[]> {
  if (!source) return of([]);
  if (isObservable(source)) return source as Observable<T[]>;
  if (source instanceof Promise) return from(source);
  return of(source);
}

export function formatSnakeCase(text: string): string {
  return text
    .split("_")
    .map((word, index) =>
      index === 0
        ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        : word.toLowerCase()
    )
    .join(" ");
}